import { render, staticRenderFns } from "./PEMCatagory.vue?vue&type=template&id=13c31b8b&scoped=true&"
import script from "./PEMCatagory.vue?vue&type=script&lang=js&"
export * from "./PEMCatagory.vue?vue&type=script&lang=js&"
import style0 from "./PEMCatagory.vue?vue&type=style&index=0&id=13c31b8b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c31b8b",
  null
  
)

export default component.exports